import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SharedService } from './sharedService';
import { catchError, tap, map } from 'rxjs/operators';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class ApplicationService extends BaseService{
  
  changeApplicationStatus(resourceUrl: string, resource: any): Observable<any> {
      return this.http.put<any>(this.sharedService.apiUrl(resourceUrl), resource, super.httpOptions).pipe(
        tap((resource: any) => this.log(`statusChange ${resourceUrl} w/ id=${resource.id}`)),
        catchError(this.handleError<any>('statusChange'))
      );
  }

  downloadFile(name: any): Observable<Blob> {
    const httpOptionsPDF = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: 'blob' as 'json', 
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('application/file')+name, httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('download file'))
    )
    return process$;

  }

  getLocations(resourceUrl:string): Observable<any> {
    return this.http.get(this.sharedService.apiUrl(resourceUrl)).pipe(
      map(res => {
        return res;
      })
    );
  }

  getPhotoBlob(photoPath: string): Observable<Blob> {
    const fileName = photoPath.split('/').pop();
    return this.http.get(
      this.sharedService.apiUrl('application/photo/' + fileName),
      { responseType: 'blob' }
    );
  }

  updateApplication(id: string, application: any): Observable<any> {
    return this.http.put<any>(
      this.sharedService.apiUrl('application/' + id),
      application,
      super.httpOptions
    ).pipe(
      tap((resource: any) => this.log(`updated application id=${id}`)),
      catchError(this.handleError<any>('updateApplication'))
    );
  }

  deleteApplication(id: string) {
    return this.http.delete<any>(
      this.sharedService.apiUrl('application/' + id),
      super.httpOptions
    ).pipe(
      tap(() => this.log(`deleted application id=${id}`)),
      catchError(this.handleError<any>('deleteApplication'))
    );
  }

  mergeApplication(applicationId: string, taxpayerId: string) {
    return this.http.put<any>(
      this.sharedService.apiUrl('application/' + applicationId + '/merge'),
      { taxpayerId: taxpayerId },
      super.httpOptions
    );
  }

}
